import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './teamsLanding.css';
import TeamGrid from '../../components/Team/TeamGrid';
import * as teamsSelectors from '../../../store/reducers/teams.selectors';
import TeamsType from '../../../lib/proptypes/teams';
import { gciPageView } from '../../../lib/analytics';

const pageTitle = 'NFL Teams';

const mapStateToProps = state => ({
  teams: teamsSelectors.selectTeamsHierarchy(state),
});

class TeamsLanding extends Component {
  static propTypes = {
    teams: TeamsType.isRequired,
  };

  render() {
    const { teams } = this.props;

    return (
      <div className={classes.teamsLandingWrapper}>
        <div className={classes.teamsHeader}>{pageTitle}</div>
        <TeamGrid teams={teams} hasSubLinks />
      </div>
    );
  }

  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
  }

}

export default connect(mapStateToProps)(TeamsLanding);



// WEBPACK FOOTER //
// ./src/app/views/TeamsLanding/TeamsLanding.js